<template>
  <span
    :class="cn(
      'tw:text-muted-foreground tw:flex tw:items-center tw:gap-2 tw:text-sm tw:[&_svg]:pointer-events-none tw:[&_svg:not([class*=\'size-\'])]:size-4',
      'tw:text-base',
      props.class,
    )"
  >
    <slot />
  </span>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
